<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'RouterViewPage',
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
